import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * ProtectedRoute Component
 * 
 * Protects routes by requiring authentication.
 * Redirects to login if user is not authenticated.
 * Checks role hierarchy if requiredRole is specified.
 */
export default function ProtectedRoute({ children, requiredRole }) {
  const { currentUser, userProfile, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          textAlign: 'center'
        }}>
          <div style={{ 
            fontSize: '48px',
            marginBottom: '20px'
          }}>⏳</div>
          <div style={{
            fontSize: '18px',
            color: '#333',
            fontWeight: '500'
          }}>Loading...</div>
        </div>
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Check role if required
  if (requiredRole && userProfile) {
    const roleHierarchy = {
      viewer: 1,
      engineer: 2,
      manager: 3,
      admin: 4,
    };
    
    const userRoleLevel = roleHierarchy[userProfile.role] || 0;
    const requiredRoleLevel = roleHierarchy[requiredRole] || 0;
    
    if (userRoleLevel < requiredRoleLevel) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // User is authenticated and has required role - allow access
  // Subscription check is done in individual components via useSubscription hook
  return children;
}
